import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  ViewEncapsulation,
} from "@angular/core";
import { Dictionary } from "src/app/store/models/common_types";
import { faRedo } from "@fortawesome/free-solid-svg-icons";
import { UntypedFormControl } from "@angular/forms";
import { VAIconRegistryService, redo } from "@va/core-library/icons";

@Component({
  selector: "app-multi-select-dropdown",
  templateUrl: "./multi-select-dropdown.component.html",
  styleUrls: ["./multi-select-dropdown.component.scss"],
  encapsulation: ViewEncapsulation.None,
})
export class MultiSelectDropdownComponent implements OnInit {
  @Input() data: Dictionary<any>;
  @Input() title: string;
  @Output() callback: EventEmitter<any> = new EventEmitter();
  @Output() maxLimitViolation: EventEmitter<any> = new EventEmitter();
  selectedList = [];
  selectedListCopy = [];
  filterSelected = false;
  faRedo = faRedo;
  headerText = "";
  maxLimit = -1;
  // Adding input as a FormControl so that we can use the valueChanges method
  queryField: UntypedFormControl = new UntypedFormControl();
  popoverOpen = false;

  // icons
  constructor(private iconRegistry: VAIconRegistryService) {
    this.iconRegistry.registerIcons([redo]);
  }

  ngOnInit() {
    return;
  }
  ngOnChanges() {
    this.selectedList = this.data.list
      .filter((val) => {
        if (val.checked) {
          return val.value;
        }
        return false;
      })
      .map((v) => {
        return v.value;
      });

    this.selectedListCopy = JSON.parse(JSON.stringify(this.selectedList));

    this.headerText =
      this.selectedList.length > 0
        ? `${this.data.headerText} (${this.selectedList.length}) `
        : this.data.headerText;
    this.filterSelected = this.selectedList.length > 0;
    this.maxLimit = this.data.maxLimit ? this.data.maxLimit : -1;
  }
  popoverChange() {
    this.popoverOpen = !this.popoverOpen;
    if (this.popoverOpen === false) {
      this.filterSelected = this.selectedList.length > 0;
      this.headerText =
        this.selectedList.length > 0
          ? `${this.data.headerText} (${this.selectedList.length}) `
          : this.data.headerText;
      this.callback.emit(this.selectedList);
    }
  }
  onChanges(value): void {
    if (this.maxLimit !== -1 && value.length > this.maxLimit) {
      const violator = value.filter((v) => !this.selectedList.includes(v))[0];
      const violatorIndex = this.data.list.findIndex((v) => {
        return v.value === violator;
      });
      setTimeout(() => {
        if (violatorIndex !== -1) {
          this.data.list[violatorIndex].checked = false;
        }
      }, 5);
      this.maxLimitViolation.emit({
        limit: this.maxLimit,
        selected: value.length,
        violatorIndex: violatorIndex,
        violator: violator,
      });
      return;
    }
    this.selectedList = value;
  }

  isHidden(value) {
    if (!value) {
      return true;
    }
    if (!this.queryField.value || this.queryField.value === "") {
      return false;
    }
    if (!value.toLowerCase().includes(this.queryField.value.toLowerCase())) {
      return true;
    }
    return false;
  }
  resetAll() {
    this.selectedList = [];
    this.data.list.forEach((element) => {
      if (!element.disabled) {
        element.checked = false;
      } else if (element.disabled && element.checked) {
        this.selectedList.push(element.value);
      }
    });

    if (this.title === "charts") {
      this.selectedList = this.selectedListCopy;
      this.data.list = this.data.list.map((data) => {
        const value = data;
        if (this.selectedList.indexOf(data.value) > -1) {
          value.checked = true;
        } else {
          value.checked = false;
        }
        return value;
      });
    }

    this.headerText =
      this.selectedList.length > 0
        ? `${this.data.headerText} (${this.selectedList.length}) `
        : this.data.headerText;
    this.callback.emit(this.selectedList);
  }
}
